export default __webpack_public_path__ + "static/media/team-1.a5c4d479.png";